import { useEffect } from "react";
import { Collapse } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import { useEventTagContext } from "../../context/EventTagContext/EventTagContext";
import { EventTagItems } from "./constants";

const AddEventTag = () => {
	const { addEventTag, clearEventTagFormData, operationStatus } = useEventTagContext();

	useEffect(() => {
		clearEventTagFormData();

		return () => {
			clearEventTagFormData();
		};
	}, []);

	return (
		<>
			<BackComponent text="Etiket Listesine Dön" to="/event-tags" style={{ marginBottom: "24px" }} />
			<ActionContainer>
				<ActionItemsContainer>
					<FormHeaderComponent>Etiket Ekleme</FormHeaderComponent>
					<Collapse
						items={EventTagItems}
						expandIconPosition="end"
						bordered={false}
						ghost
						expandIcon={CollapseExpandIcon}
						defaultActiveKey={["1"]}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={addEventTag} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
							Etiket Ekle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</ActionContainer>
		</>
	);
};

export default AddEventTag;
